import { TagInputProps, TagInput } from '@blueprintjs/core'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../store'

interface EmailSelectorProps {
  values: string[]
  onChange: (values: string[]) => void
  tagInputProps?: TagInputProps
  autoPopulateUserEmail?: boolean
}

/**
 * Use this component for multi-email selection
 * Will auto populate the select if the user has an email
 */
const EmailSelector: React.FC<EmailSelectorProps> = ({
  values,
  onChange,
  tagInputProps,
  autoPopulateUserEmail = true
}) => {
  const userEmail = useSelector((s: AppState) => s.current.user.email)
  const emails = autoPopulateUserEmail === true ? [userEmail] : []

  React.useEffect(() => {
    onChange(emails)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount only
  }, [])

  return (
    <TagInput
      leftIcon="envelope"
      placeholder="alex@example.com"
      addOnBlur
      fill
      onChange={onChange}
      values={values}
      tagProps={{ minimal: true }}
      {...tagInputProps}
    />
  )
}

export default EmailSelector
